const buttonState = (e, t, n = null) => {
  (e.disabled = !t), (e.textContent = n || e.dataset.defaultText);
};
const throwException = (e) => {
  console.error(e);
  throw new Error(e);
};

const sugarRequest = async (elementsToFill, path) => {
  // const SUGAR_LAMBDA_URI = "https://bxyu3yp44c5edtr5o7dmazdyqy0bchrj.lambda-url.us-east-1.on.aws";
  const SUGAR_LAMBDA_URI = "https://g3idjd4ug7qgixqwo5u5nzohue0zpzoq.lambda-url.us-east-2.on.aws";
  const payload = {};

  elementsToFill.forEach((elem) => {
    const key = elem.dataset.key;

    if (path === "lead" && key === "fullName") {
      const [firstName, ...lastName] = elem.value.split(" ");
      payload.firstName = firstName;
      payload.lastName = lastName.length ? lastName.join(" ") : "-";

      return;
    }

    if (key) {
      payload[key] = elem.value;
    }
  });

  payload.interest = payload.interest || "null";
  //payload['forceStaging'] = 'staging'

  try {
    const request = await fetch(`${SUGAR_LAMBDA_URI}/${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const response = await request.json();

    return response;
  } catch (err) {
    throw err;
  }
};

const creatioRequest = async (elemsToFill, path) => {
  const CREATIO_LAMBDA_URI = "https://lsmpvo2wchbvwp247elvfizore0vlrtz.lambda-url.us-east-2.on.aws";
  const payload = {};

  elemsToFill.forEach((elem) => {
    const key = elem.dataset.key;
    if (key) {
      payload[key] = elem.value;
    }
  });

  try {
    const request = await fetch(`${CREATIO_LAMBDA_URI}/creatio/${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (request.status && request.status >= 400) {
      throw { message: res.msg };
    }

    return request;
  } catch (err) {
    throw err;
  }
};

const daviviendaRequest = async (data) => {
  // const DAVI_LAMBDA_URI = "https://ch5bnc737qddkfqc4zdtuhf5gy0rpwqq.lambda-url.us-east-1.on.aws";
  const DAVI_LAMBDA_URI = "https://zcjtlzqo6fsak37jrarrivzara0bpfrf.lambda-url.us-east-2.on.aws";
  const payload = {
    userAgent: navigator.userAgent,
    urlPath: location.pathname,
    ...data,
  };

  try {
    const request = await fetch(`${DAVI_LAMBDA_URI}/api/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const response = await request.json();

    return response;
  } catch (err) {
    throw err;
  }
};

function dropdownPdp(classBtn, classContainer) {
  const btn = document.querySelector(classBtn);
  if (btn) {
    const containerdropdown = document.querySelector(classContainer);
    btn.addEventListener("click", (evt) => {
      evt.preventDefault();
      if (containerdropdown.parentElement.classList.contains("container_dropdown")) {
        if (containerdropdown.nextElementSibling) {
          containerdropdown.nextElementSibling.style.height = "0px";
          containerdropdown.nextElementSibling.classList.remove("open");
        }
        if (containerdropdown.previousElementSibling) {
          containerdropdown.previousElementSibling.style.height = "0px";
          containerdropdown.previousElementSibling.classList.remove("open");
        }
      }
      containerdropdown.classList.toggle("open");

      if (containerdropdown.classList.contains("open")) {
        containerdropdown.style.height = `${containerdropdown.scrollHeight}px`;
      } else {
        containerdropdown.style.height = "0px";
      }
    });
  }
}

function quoter(classInputLowstPrice, classInputNewPrice, classSelect) {
  const lowestPrice = document.querySelector(classInputLowstPrice);
  const newPrice = document.querySelector(classInputNewPrice);
  if (lowestPrice) {
    const minPrice = parseInt(document.querySelector(classSelect).dataset.minPrice);
    const numberQuoter = parseInt(document.querySelector(classSelect).dataset.quoter);
    const percentage = parseInt(document.querySelector(classSelect).dataset.percentage);

    lowestPrice.addEventListener("input", (evt) => {
      evt.preventDefault();
      let price = (parseInt(document.querySelector(classSelect).value) * percentage) / 100;
      let setPrice = price - parseInt(evt.target.value);
      if (setPrice > minPrice) {
        newPrice.textContent = `${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(setPrice / numberQuoter)}*`;
        lowestPrice.nextElementSibling.textContent = "";
      } else {
        newPrice.textContent = "$00.00*";
        lowestPrice.nextElementSibling.textContent = "El monto mínimo a financiar debe ser de $1.500.000.";
      }
    });
  }
}

function selectTabs(dataTitle, dataBlock) {
  const allTitle = document.querySelectorAll(dataTitle);
  if (allTitle) {
    const allBlock = document.querySelectorAll(dataBlock);
    allTitle.forEach((title) => {
      title.addEventListener("click", (evt) => {
        evt.preventDefault();
        let tabActive = document.querySelector(".tab--active");

        if (tabActive) {
          tabActive.classList.remove("tab--active");
        }
        title.classList.add("tab--active");

        allBlock.forEach((block) => {
          if (title.dataset.typeTitle == block.dataset.typeBlock) {
            block.style.display = "block";
          } else {
            block.style.display = "none";
          }
        });
      });
    });
    if (location.pathname.includes("pages/tiendas")) {
      document.querySelectorAll(".store-item__text--header.text--header")[0].click();
    }
  }
}

function colorTextRadio(matchesClass) {
  document.addEventListener("click", (evt) => {
    if (evt.target.matches(matchesClass)) {
      document.querySelectorAll(matchesClass).forEach((element) => {
        if (element.nodeName == "LABEL" && element.firstElementChild.checked) {
          element.style.color = "#ccc";
          element.firstElementChild.removeAttribute("checked");
        }
      });
      evt.target.style.color = "#000";
      evt.target.firstElementChild.setAttribute("checked", "");
    }
  });
}

function selectTabs2(path, titleSelector, blockSelector) {
  if (location.pathname.includes(path)) {
    const allPromotionTitle = document.querySelectorAll(`${titleSelector} a`);
    const allPromotionBlock = document.querySelectorAll(blockSelector);
    allPromotionTitle.forEach((item) => {
      item.addEventListener("click", (evt) => {
        if (
          (evt.target.parentElement.href != undefined && evt.target.parentElement.href.includes("#")) ||
          (evt.target.parentElement.parentElement.href != undefined && evt.target.parentElement.parentElement.href.includes("#"))
        ) {
          evt.preventDefault();
        }

        let tabActive = document.querySelector(".tab--active");

        if (!item.firstElementChild.classList.contains("tab--active")) {
          tabActive.classList.remove("tab--active");
          item.firstElementChild.classList.add("tab--active");
        }
        allPromotionBlock.forEach((promotionBlock) => {
          if (
            promotionBlock.dataset.typePromotionBlock == item.dataset.typePromotionTitle ||
            promotionBlock.dataset.typeBlock == item.dataset.typePromotionTitle
          ) {
            promotionBlock.style.display = "block";
          } else {
            promotionBlock.style.display = "none";
          }
        });
      });
    });

    if (window.innerWidth <= 768) {
      $(".conditions_items-container").slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  pagesLogic();
  newsletterLogic();
  footerFormLogic();
  daviviendaPageLogic();
  pqrsPageLogic();
  registerDataPageLogic();

  const metaTitle = document.querySelectorAll(".text--header");
  const metaText = document.querySelectorAll(".meta__text");
  const open = document.querySelectorAll(".open-dropdown");
  const close = document.querySelectorAll(".close-dropdown");

  metaTitle.forEach((title, i) => {
    metaTitle[i].addEventListener("click", (e) => {
      const isOpen = metaText[i].classList.contains("meta__text--open");
      metaText[i].classList.toggle("meta__text--open");
      open[i].classList.toggle("open-dropdown-close");
      close[i].classList.toggle("close-dropdown-open");
      metaText[i].style.height = `${isOpen ? 0 : metaText[i].children[0].scrollHeight + 35}px`;
    });
  });

  $(".banner-register-data__items").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
  $(".banner-landing--items").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });

  if (window.innerWidth <= 768) {
    $(".technical-service__items").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
    });
    $(".benefits-buying__items").slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: true,
    });
  }

  selectTabs("[data-type-title]", "[data-type-block]");

  const [...allSelect] = document.querySelectorAll(".select__calculator");
  allSelect.forEach((select) => {
    select.addEventListener("change", (evt) => {
      let cuotaPrice = select.value;
      if (select.dataset.select === "retorn") {
        cuotaPrice = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(parseInt(select.value));
        select.parentElement.nextElementSibling.firstElementChild.textContent = cuotaPrice + "*";
      } else {
        cuotaPrice = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format((parseInt(select.value) * parseInt(select.dataset.percentage)) / 100 / parseInt(select.dataset.quoter));
        select.parentElement.nextElementSibling.firstElementChild.textContent = cuotaPrice + "*";
        document.querySelector(".iphone__lowest-price").style.display = "block";
      }
    });
  });

  selectTabs2("/terminos-y-condiciones", ".tabs_title-container", "[data-type-promotion-block]");
  selectTabs2("/preguntas-frecuentes", ".tabs_title-container", "[data-type-promotion-block]");
  selectTabs2("/beneficios-pe", ".benefits_tabs-container", "[data-type-block]");

  colorTextRadio(".pqrs-form__stores .stores label");
  colorTextRadio(".pqrs-form__identification .identity label");
  colorTextRadio(".pqrs-form__identification .under_age label");
  colorTextRadio(".pqrs-form__claimant-identification .claimant-identification label");
  colorTextRadio(".pqrs-form__details_title .details label");
  colorTextRadio(".pqrs-form__declaration .veracity_title label");
  colorTextRadio(".pqrs-form__declaration .privacy_policy_title label");

  const allBtnOption = document.querySelectorAll(".header__btns a");
  allBtnOption.forEach((btnOption) => {
    btnOption.addEventListener("click", (evt) => {
      evt.preventDefault();
      document.querySelector(".header__select").classList.remove("header__select");
      btnOption.classList.add("header__select");
      document.querySelectorAll("[data-type-option]").forEach((typeOption) => {
        if (typeOption.dataset.typeOption != btnOption.dataset.buttonType) {
          typeOption.style.display = "none";
        } else {
          if (typeOption.parentElement.classList == "") {
            typeOption.style.display = "flex";
            return;
          }
          typeOption.style.display = "block";
        }
      });
    });
  });

  quoter('[data-lowest-price="iphone"]', '[data-new-price="iphone"]', '[data-select="iphone"]');
  quoter('[data-lowest-price="ipad"]', '[data-new-price="ipad"]', '[data-select="ipad"]');

  const consultRenewal = document.querySelector(".date-renovation a");
  let inputCedula = document.querySelector(".date-renovation input");
  let textConsulRenewal = document.querySelector(".date-renovation__text");
  if (consultRenewal) {
    consultRenewal.addEventListener("click", async (evt) => {
      evt.preventDefault();
      try {
        fetch("https://cdn.shopify.com/s/files/1/0604/8373/1606/t/10/assets/cedulas.json")
          .then((response) => response.json())
          .then((data) => {
            let existCedula = data.find((cedula) => inputCedula.value === cedula.Identificacion);

            if (existCedula) {
              textConsulRenewal.textContent = `¡Que bien! Ya te encuentras dentro del Programa iPhone for Life. Tu fecha de renovación es el ${existCedula.Fecha_Renovacion}`;
            } else {
              textConsulRenewal.textContent =
                "No te encontramos en nuestra base de datos. Recuerda que con Mac Center puedes entrar al programa iPhone for life ¡Inscríbete ya!.";
            }
          });
      } catch (error) {
        console.error(error);
      }
    });
  }

  dropdownPdp(".financing", ".financing__appropriate");
  dropdownPdp(".davivienda", ".davivienda__dropdown");
  dropdownPdp(".addi", ".addi__dropdown");

  const containerdropdown = document.querySelector(".form-divided");
  if (containerdropdown) {
    const btn = containerdropdown.firstElementChild;
    containerdropdown.style.height = `${containerdropdown.firstElementChild.scrollHeight + 15}px`;

    btn.addEventListener("click", (evt) => {
      containerdropdown.classList.toggle("open");
      if (containerdropdown.classList.contains("open")) {
        containerdropdown.style.height = `${containerdropdown.scrollHeight}px`;
      }
    });
  }

  const warrantyInfo = document.querySelector("[data-warranty]");
  if (warrantyInfo) {
    warrantyData = warrantyInfo.dataset.warranty.replace(/\D/g, "");
    warrantyInfo.textContent = `Garantía de ${warrantyData} año`;
  }
});

const pagesLogic = () => {
  if (!location.pathname.includes("/pages")) {
    return;
  }

  $(".grid-landing__one--carousel").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
  $(".grid-landing__two--carousel").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
  $(".grid-landing__three--first-carousel").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
  $(".grid-landing__three--second-carousel").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
  $(".container__product-landing-carousel").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
};

const newsletterLogic = async () => {
  const buttonNewsletter = document.querySelector(".newsletter-form__button.field__button");
  if (!buttonNewsletter) {
    return;
  }

  const form = buttonNewsletter.form;
  const [...requiredElementsNestletter] = form.querySelectorAll('input[required], input[type="hidden"]');
  form.addEventListener("submit", async (evt) => {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    const filledElementsnNesletter = requiredElementsNestletter.filter((elem) => {
      const tagName = elem.tagName.toLowerCase();
      if (tagName === "input") {
        return elem.value !== "";
      }

      return elem.selectedIndex !== 0;
    });

    if (filledElementsnNesletter.length < requiredElementsNestletter.length) {
      return throwException("Something went wrong filling required elements.");
    }
    try {
      const res = await sugarRequest(filledElementsnNesletter, "lead");
      if (res.statusCode && res.statusCode === 500) {
        throw { message: res.msg };
      }
      console.log("Formulario enviado con exito");
    } catch (err) {
      console.error(err);
    }
  });
};

const footerFormLogic = async () => {
  const buttonFooterForm = document.querySelector(".footer_form-button");
  if (!buttonFooterForm) {
    return;
  }

  const form = buttonFooterForm.form;
  const [...requiredElements] = form.querySelectorAll("input[required], select[required]");
  form.addEventListener("submit", async (evt) => {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    const filledElements = requiredElements.filter((elem) => {
      const tagName = elem.tagName.toLowerCase();
      if (tagName === "input") {
        return elem.value !== "";
      }
      return elem.selectedIndex !== 0;
    });

    if (filledElements.length < requiredElements.length) {
      return throwException("Something went wrong filling required elements.");
    }

    const confirmation = document.querySelector(".confirmation_message") || document.createElement("p");
    confirmation.classList.add("confirmation_message");
    buttonFooterForm.closest(".form-container")?.appendChild(confirmation);

    try {
      buttonState(buttonFooterForm, false, "Enviando...");
      const res = await sugarRequest(filledElements, "lead");

      if (res.statusCode && res.statusCode === 500) {
        throw { message: res.msg };
      }

      confirmation.textContent = `Formulario enviado con exito!`;
      confirmation.classList.add("confirmation__text");
      buttonFooterForm.remove();
    } catch (err) {
      console.error(err);
      confirmation.setAttribute("style", "color:red");
      confirmation.textContent = `Status: ${err.message}`;

      buttonState(buttonFooterForm, true, "SUSCRÍBETE");
    }
  });
};

const daviviendaPageLogic = async () => {
  if (!location.pathname.includes("/pages/davivienda")) {
    return;
  }

  const btnFormDavivienda = document.querySelector(".sendDaviviendaForm");
  const formDavivienda = btnFormDavivienda.form;
  const [...requiredElements] = formDavivienda.querySelectorAll('input[required]:not(*[type="radio"])');
  formDavivienda.addEventListener("submit", async (evt) => {
    evt.preventDefault();

    const filledElements = requiredElements.filter((elem) => {
      const tagName = elem.tagName.toLowerCase();
      if (tagName === "input") {
        return elem.value !== "";
      }
      return elem.selectedIndex !== 0;
    });

    if (filledElements.length < requiredElements.length) {
      return throwException("Something went wrong filling required elements.");
    }

    const confirmation = document.createElement("p");
    btnFormDavivienda.parentElement && btnFormDavivienda.parentElement.appendChild(confirmation);

    try {
      buttonState(btnFormDavivienda, false, "Enviando...");
      const resSugar = await sugarRequest(filledElements, "lead");
      if (resSugar.statusCode && resSugar.statusCode === 500) {
        throw { message: resSugar.msg };
      }

      const resDavivienda = await daviviendaRequest({
        docNumber: filledElements.find((elem) => elem.dataset.key === "identificationNumber").value,
        product: {
          id: "TMA",
        },
      });
      const { message, url } = resDavivienda;
      if (message) {
        throw { message: resDavivienda.message };
      }

      btnFormDavivienda.remove();
      location.href = url;
    } catch (err) {
      console.error(err);
      confirmation.setAttribute("style", "color:red");
      confirmation.textContent = `Error al enviar formulario. \nStatus: ${err.message}`;
      buttonState(btnFormDavivienda, true);
    }
  });
};

const pqrsPageLogic = async () => {
  if (!location.pathname.includes("/pages/pqrs")) {
    return;
  }

  const inputDate = document.querySelector('[data-key="date"]');
  const pqrsButton = document.querySelector(".pqrs-form__btn button");
  const form = pqrsButton.form;
  const [...requiredElements] = form.querySelectorAll('input[required]:not(*[type="radio"]),textarea[required],[data-radio-group]');

  if (!pqrsButton || requiredElements.length <= 0) {
    return;
  }

  form.addEventListener("submit", async (evt) => {
    evt.preventDefault();
    const [...filledElements] = form.querySelectorAll(
      'input[required]:not(*[type="radio"]),textarea[required],[data-radio-group] input:checked,select[required]',
    );

    if (filledElements.length < requiredElements.length) {
      return throwException("Something went wrong filling required elements.");
    }

    const confirmation = document.createElement("span");
    pqrsButton.parentElement && pqrsButton.parentElement.appendChild(confirmation);
    let pqrsTextSucces = document.querySelector("[data-pqrs-success-message]").dataset.pqrsSuccessMessage;

    try {
      buttonState(pqrsButton, false, "Enviando...");
      // MOXIE: en Panamá PQRS va a Sugar como "cases" y muestra el código de caso, igual que el bundle de producción
      const res = await sugarRequest(filledElements, "cases");

      confirmation.innerHTML = pqrsTextSucces.replace("$PQR_RESPONSE", res.caseCode);
      pqrsButton.parentElement.classList.add("confirmation__text");
      pqrsButton.remove();
    } catch (err) {
      console.error(err);
      confirmation.setAttribute("style", "color:red");
      confirmation.textContent = `Error al enviar formulario. \nStatus: ${err.message}`;
      buttonState(pqrsButton, true);
    }
  });
};

const registerDataPageLogic = async () => {
  if (!location.pathname.includes("/pages/registro-de-datos")) {
    return;
  }
  const btnFormRegisterData = document.querySelector(".registerButton");
  const form = btnFormRegisterData.form;
  const [...requiredElements] = form.querySelectorAll("input[required], select[required]");
  form.addEventListener("submit", async (evt) => {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    const filledElements = requiredElements.filter((elem) => {
      const tagName = elem.tagName.toLowerCase();
      if (tagName === "input") return elem.value !== "";
      return elem.selectedIndex !== 0;
    });

    if (filledElements.length < requiredElements.length) {
      return throwException("Something went wrong filling required elements.");
    }

    const confirmation = document.querySelector(".confirmation_message") || document.createElement("p");
    confirmation.classList.add("confirmation_message");
    btnFormRegisterData.parentElement.appendChild(confirmation);

    try {
      buttonState(btnFormRegisterData, false, "Enviando...");
      const res = await sugarRequest(filledElements, "lead");

      if (res.statusCode && res.statusCode === 500) {
        throw { message: res.msg };
      }

      confirmation.textContent = `Formulario enviado con exito!`;
      confirmation.classList.add("confirmation__text");
      btnFormRegisterData.remove();
    } catch (err) {
      console.error(err);
      confirmation.setAttribute("style", "color:red");
      confirmation.textContent = `Status: ${err.message}`;

      buttonState(btnFormRegisterData, true, "SUSCRÍBETE");
    }
  });
};
